import { PaginatedResponse } from "./common";

export type UserRegistry = {
	id: string;
	firstName: string;
	lastName: string;
	username: string;
	email: string;
	telephone: string;
	preferredLanguage: string;
	roleId: string;
	roleDescription: string;
	status: number;
	blocked: boolean;
	multiFactorAuthenticationEnabled: boolean;
	isProtected: boolean;
	expiredAt?: string;
};

export type PaginatedUsers = PaginatedResponse<UserRegistry>;

export const emptyUserRegistry = {
	id: "",
	firstName: "",
	lastName: "",
	username: "",
	email: "",
	telephone: "",
	preferredLanguage: "en",
	roleId: "",
	roleDescription: "",
	status: 1,
	blocked: false,
	multiFactorAuthenticationEnabled: false,
	isProtected: false,
	expiredAt: "",
};
